var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pos-content-container",attrs:{"data-scrollbar":"true","data-height":"100%","data-skip-mobile":"true"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }